import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M38.18 24.985a.894.894 0 0 1 1.788 0c0 3.101-.115 6.185-.346 9.252a8.045 8.045 0 0 1-7.418 7.417 122.823 122.823 0 0 1-18.445 0 8.045 8.045 0 0 1-7.417-7.418 123.546 123.546 0 0 1 .006-18.441 8.045 8.045 0 0 1 7.417-7.418c3.056-.23 6.129-.345 9.22-.345a.894.894 0 1 1 0 1.787 120.8 120.8 0 0 0-9.085.341 6.257 6.257 0 0 0-5.77 5.77 121.76 121.76 0 0 0-.006 18.172 6.257 6.257 0 0 0 5.77 5.77c3.012.227 6.043.34 9.09.34 3.046 0 6.074-.113 9.086-.34a6.257 6.257 0 0 0 5.769-5.77c.228-3.022.342-6.06.342-9.117Zm.746-17.176a1.554 1.554 0 0 0-.258-.021h-8.94a.894.894 0 1 1 0-1.788h8.94A3.332 3.332 0 0 1 42 9.332v8.939a.894.894 0 1 1-1.788 0V9.33a1.55 1.55 0 0 0-.021-.258L29.546 19.716c-.843.842-2.107-.422-1.264-1.265L38.926 7.81Z"
    }
  )
);
var SvgExternalOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ExternalOutlined_default = SvgExternalOutlined;

export { ExternalOutlined_default as default };
